'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Takes a selector that returns a color string and returns new decorated selector that calls the
 * original function to get the color and then modifies that color, ultimately returning another
 * color string.
 */
var addModifier = function addModifier(fn, method) {
  for (var _len = arguments.length, modifierArgs = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    modifierArgs[_key - 2] = arguments[_key];
  }

  return function () {
    var _ref;

    return (_ref = new _color2.default(fn.apply(undefined, arguments)))[method].apply(_ref, modifierArgs).rgbString();
  };
};

exports.default = addModifier;


//////////////////
// WEBPACK FOOTER
// ./~/styled-components-theme/lib/addModifier.js
// module id = 1025
// module chunks = 0